// import components
import { styled, Box, Typography, TypographyProps } from '@mui/material';

export const StyledToggleGroupBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  marginLeft: theme.spacing(5),

  '& .MuiFormControl-root': {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    alignItems: 'baseline',
    justifyContent: 'start'
  },

  '& .MuiFormControl-root.read_mode > label': {
    position: 'relative',
    display: 'contents'
  }
}));

export const StyledLabelTypography = styled(Typography)<TypographyProps>(
  () => ({
    width: '25%'
  })
);
